import { useEffect } from 'react';
import { useLocation } from 'react-router';

/**
 * The `?ref=` code an invitee arrived with (PRD §4.2 step 4). Captured on any page, kept for
 * 30 days so a visitor who comes back later is still attributed, and sent with the checkout.
 */
const KEY = 'gg_ref';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;

export function captureReferralCode(search: string): void {
  const code = new URLSearchParams(search).get('ref')?.trim();
  if (!code) return;
  try {
    localStorage.setItem(KEY, JSON.stringify({ code, at: Date.now() }));
  } catch {
    // Storage disabled: the code still travels in the URL to /register.
  }
}

export function storedReferralCode(): string | undefined {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return undefined;
    const { code, at } = JSON.parse(raw) as { code?: string; at?: number };
    if (!code || !at || Date.now() - at > TTL_MS) return undefined;
    return code;
  } catch {
    return undefined;
  }
}

/** Captures `?ref=` on every navigation; used by both layouts. */
export function useCaptureReferralCode(): void {
  const { search } = useLocation();
  useEffect(() => captureReferralCode(search), [search]);
}
